import { formatDateTime } from "@core/utils/filter";
import {
  saveDbFilterData,
  getDbFilterData,
  CURRENT_FILTER_KEY,
  PREVIOUS_FILTER_KEY
} from '@/@core/utils/filterDB';

export default {
  namespaced: true,
  state: {
    configs: {
      homePage: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Brands", value: "B000001" }], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          homeDate: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
        },
        hierarchy: [["brand", ["homeDate"]]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
          "/global/filters/date": {
            homeDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          },
        },
      },
      overviewPages: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Brands", value: "B000001" }], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [
                {
                  title: "All Campaigns",
                  value: null,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["brand", ["activeCampaigns", ["campaign", ["date"]]]]],
        visualHierarchy: ["brand", "campaign", "date", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
                adin_id: "$campaign$",
              },
            },
          },
        },
      },
      overviewPagesNoAll: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["brand", ["activeCampaigns", ["campaign", ["date", ["applybtn"]]]]],],
        visualHierarchy: [["brand", "campaign", "activeCampaigns"], ["date","applybtn"]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
                adin_id: "$campaign$",
              },
            },
          },
        },
      },
      defaultPages: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["brand", "activeCampaigns", ["campaign"]]],
        visualHierarchy: ["brand", "campaign", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
              },
            },
          },
        },
      },
      defaultReportPages: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["brand", "activeCampaigns", ["campaign", ["applybtn"]]]],
        visualHierarchy: ["brand", "campaign", "activeCampaigns", "applybtn"],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
              },
            },
          },
        },
      },
      seoDefault: {
        components: {
          // brand Selection
          seoBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          seoDomain: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Domain",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // month Selection
          seoMonth: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Month",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["seoBrand", ["seoDomain", ["seoMonth"]]]],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            seoBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "seo-overview",
              },
            },
            seoDomain: {
              responseKey: "domainFilter",
              params: {
                pageName: "seo-overview",
                brand_id: "$seoBrand$", // argumentName : componentValue
              },
            },
            seoMonth: {
              responseKey: "monthFilter",
              params: {
                pageName: "seo-overview",
                brand_id: "$seoBrand$", // argumentName : componentValue
              },
            },
          },
        },
      },
      seoWithEvent: {
        components: {
          // brand Selection
          seoBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              dataType: "brand",
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          seoDomain: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Domain",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // month Selection
          seoMonth: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Month",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // product Selection
          seoEvent: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Event",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["seoBrand", ["seoDomain", ["seoMonth", ["seoEvent"]]]]],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            seoBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "seo-overview",
              },
            },
            seoDomain: {
              responseKey: "domainFilter",
              params: {
                pageName: "seo-overview",
                brand_id: "$seoBrand$", // argumentName : componentValue
              },
            },
            seoMonth: {
              responseKey: "monthFilter",
              params: {
                pageName: "seo-overview",
                brand_id: "$seoBrand$", // argumentName : componentValue
              },
            },
            seoEvent: {
              responseKey: "eventFilter",
              params: {
                pageName: "seo-overview",
                brand_id: "$seoBrand$", // argumentName : componentValue
              },
            },
          },
        },
      },
      seoComparison: {
        components: {
          // brand Selection
          seoBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          seoDomain: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Domain",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date1: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: null,
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          date2: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: null,
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
        },
        hierarchy: [["seoBrand", ["seoDomain", ["date1", ["date2"]]]]],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            seoBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "seo-overview",
              },
            },
            seoDomain: {
              responseKey: "domainFilter",
              params: {
                pageName: "seo-overview",
                brand_id: "$seoBrand$", // argumentName : componentValue
              },
            },
          },
          "/global/filters/date": {
            date1: {
              responseKey: "campaignDateInfo",
              params: {},
            },
            date2: {
              responseKey: "campaignDateInfo",
              params: {},
            },
          },
        },
      },
      considerationApp: {
        components: {
          // brand Selection
          considerationAppBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["considerationAppBrand", "activeCampaigns", ["campaign"]]],
        visualHierarchy: ["considerationAppBrand", "campaign", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            considerationAppBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "consideration",
                sourceType: "app",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "consideration",
                brand_id: "$considerationAppBrand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
                sourceType: "app",
              },
            },
          },
        },
      },
      considerationWeb: {
        components: {
          // brand Selection
          considerationWebBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["considerationWebBrand", "activeCampaigns", ["campaign"]]],
        visualHierarchy: ["considerationWebBrand", "campaign", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            considerationWebBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "consideration",
                sourceType: "web",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "consideration",
                brand_id: "$considerationWebBrand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
                sourceType: "web",
              },
            },
          },
        },
      },
      conversionAppWithEvent: {
        components: {
          // brand Selection
          conversionAppBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              dataType: "brand",
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // product Selection
          event: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Event",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["conversionAppBrand", ["activeCampaigns", ["campaign", ["event"]]]]],
        visualHierarchy: ["conversionAppBrand", "campaign", "event", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            conversionAppBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "conversion",
                sourceType: "app",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "conversion",
                brand_id: "$conversionAppBrand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
                sourceType: "app",
              },
            },
            event: {
              responseKey: "eventNames",
              params: {
                pageName: "conversion",
                brand_id: "$conversionAppBrand$",
                adin_id: "$campaign$", // argumentName : componentValue
                sourceType: "app",
              },
            },
          },
        },
      },
      conversionWebWithEvent: {
        components: {
          // brand Selection
          conversionWebBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // product Selection
          event: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Event",
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["conversionWebBrand", ["activeCampaigns", ["campaign", ["event"]]]]],
        visualHierarchy: ["conversionWebBrand", "campaign", "event", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            conversionWebBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "conversion",
                sourceType: "web",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "conversion",
                brand_id: "$conversionWebBrand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
                sourceType: "web",
              },
            },
            event: {
              responseKey: "eventNames",
              params: {
                pageName: "conversion",
                brand_id: "$conversionWebBrand$",
                adin_id: "$campaign$", // argumentName : componentValue
                sourceType: "web",
              },
            },
          },
        },
      },
      compReports: {
        components: {
          // brand Selection
          comparisonBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          compDate: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          events: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Events",
              searchPlaceholder: "Search Event",
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["comparisonBrand", ["activeCampaigns", ["campaigns", "compDate", "events", ["applybtn"]],],],],
        visualHierarchy: [
          ["comparisonBrand", "campaigns", "activeCampaigns"],
          ["events", "compDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            comparisonBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "comparisonReport"
              },
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$comparisonBrand$",
                active_campaigns: "$activeCampaigns$",
                pageName: "comparisonReport"
              },
            },
            events: {
              responseKey: "eventNames",
              params: {
                pageName: "comparisonReport",
                brand_id: "$comparisonBrand$", // argumentName : componentValue
              },
            },

          },
          "/global/filters/date": {
            compDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$comparisonBrand$",
              },
            },
          },
        },
      },
      growthWithEvent: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // product Selection
          event: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Event",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["brand", ["campaign", ["event"]]]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
              },
            },
          },
          "/global/filters/additional": {
            event: {
              responseKey: "events",
              params: {
                pageName: "growth-overview",
                brand_id: "$brand$", // argumentName : componentValue
                adin_id: "$campaign$", // argumentName : componentValue
              },
            },
          },
        },
      },
      videoPage: { // DEPRECATED / NOT USED
        components: {
          // brand Selection
          videoBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Brands", value: "B000001" }], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          platform: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Platform",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
        },
        hierarchy: [["videoBrand", ["campaign", ["platform"]]]],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            videoBrand: {
              responseKey: "brandFilter",
              params: {},
            },
             campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "creative",
                brand_id: "$videoBrand$",
              },
            },
            platform: {
              responseKey: "platformFilter",
              params: {
                pageName: "creative",
                adin_id: "$campaign$", // argumentName : componentValue
                brand_id: "$videoBrand$",
              },
            },
          },
        },
      },
      optimizationPages: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          smartOptcampaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // product Selection
          objective: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Objective",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["brand", ["smartOptcampaign", ["objective"]]]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
          "/global/filters/additional": {
            objective: {
              responseKey: "objectiveFilter",
              params: {
                pageName: "smartOptimization",
                brand_id: "$brand$", // argumentName : componentValue
                adin_id: "$smartOptcampaign$", // argumentName : componentValue
              },
            },
            smartOptcampaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "smartOptimization",
                brand_id: "$brand$", // argumentName : componentValue
              },
            },
          },
        },
      },
      algorithmicOptimizationPages: {
        components: {
          algorithmicBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          algorithmicPlatform: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Platforms",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Platforms", value: null }],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          algorithmicCampaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Campaigns", value: null }],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["algorithmicBrand", ["algorithmicPlatform", ["algorithmicCampaign"]]]],
        apiRules: {
          "/algorithmicopt/filter": {
            algorithmicBrand: {
              responseKey: "brandFilter",
              params: {},
            },
            algorithmicPlatform: {
              responseKey: "platformFilter",
              params: {
                brand_id: "$algorithmicBrand$",
              },
            },
            algorithmicCampaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$algorithmicBrand$",
                platform: "$algorithmicPlatform$",
              },
            },
          },
        },
      },
      onlyBrand: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Brands", value: "B000001" }],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
        },
        hierarchy: [["brand"]],
        visualHierarchy: ["brand"],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
        },
      },
      searchLiftPage: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // product Selection
          keyword: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Keyword",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
        },
        hierarchy: [["brand", ["campaign", ["keyword"]]]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
              },
            },
          },
          "/global/filters/additional": {
            keyword: {
              responseKey: "awarenessFilter",
              params: {
                pageName: "awareness",
                adin_id: "$campaign$", // argumentName : componentValue
                brand_id: "$brand$",
              },
            },
          },
        },
      },
      auditPage: {
        components: {
          financialTerm: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Financial Term",
            },
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["financialTerm"]],
        apiRules: {
          "/global/filters/additional": {
            financialTerm: {
              responseKey: "financialTerms",
              params: {
                pageName: "financialPage",
              },
            },
          },
        },
      },
      quarterlyKpiReport: {
        components: {
          year: {
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select Year",
            },
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          quarter: {
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select Quarter",
            },
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          kpiList: {
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select Kpi Group",
            },
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["year", "quarter", "kpiList", ["applybtn"]]],
        apiRules: {
          "/global/filters/additional": {
            year: {
              responseKey: "yearFilter",
              params: {
                pageName: "quarterly_kpi_report"
              },
            },
            quarter: {
              responseKey: "quarterFilter",
              params: {
                pageName: "quarterly_kpi_report",
              },
            },
            kpiList: {
              responseKey: "kpiGroupFilter",
              params: {
                pageName: "quarterly_kpi_report",
              },
            },
          },
        },
      },
      reportsWproduct: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          product: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Product",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["brand", ["product", ["date", ["applybtn"]]]]],
        visualHierarchy: ["brand", "product", "date", "applybtn"],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          },
          "/global/filters/additional": {
            product: {
              responseKey: "productFilter",
              params: {
                pageName: "custom",
              },
            },
          },
        },
      },
      compReportsWproduct: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          compDate: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          product: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Product",
              searchPlaceholder: "Search Product",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          events: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Events",
              searchPlaceholder: "Search Event",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["brand", ["campaigns", "product", "compDate", "events", ["applybtn"]]]],
        visualHierarchy: [
          ["brand", "campaigns", "product"],
          ["events", "compDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "false",
              },
            },
          },
          "/global/filters/date": {
            compDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          },
          "global/filters/additional": {
            events: {
              responseKey: "eventNames",
              params: {
                pageName: "conversion-overview",
                sourceType: "app",
                brand_id: "$brand$", // argumentName : componentValue
              },
            },
            product: {
              responseKey: "productFilter",
              params: {
                pageName: "custom",
              },
            },
          },
        },
      },
      campaignLabellingPage: {
        components: {
          // brand Selection
          labellingBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },

          // holistic name Selection
          holisticName: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Holistic Name",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },

        },
        hierarchy: [
          ["labellingBrand", ["holisticName"]],
        ],
        visualHierarchy: [
          "labellingBrand",
          "holisticName",
        ],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            labellingBrand: {
              responseKey: "brandFilter",
              params: {},
            }
          },
          "global/filters/additional": {
            holisticName: {
              responseKey: "holisticFilter",
              params: {
                brand_id: "$labellingBrand$", // argumentName : componentValue
                pageName: 'holistic_filter'
              },
            },
          }
        },
      },
      campaignLabellingWithCampaign: {
        components: {
          // brand Selection
          labellingBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },

          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date("2023-01-01")),
                  endDate: formatDateTime(new Date()),
                },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },

          // holistic name Selection
          holisticName: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Holistic Name",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
        },
        hierarchy: [
          ["labellingBrand", ["campaign", ["holisticName"]]],
        ],
        visualHierarchy: [
          "labellingBrand",
          "campaign",
          "holisticName",
        ],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            labellingBrand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$labellingBrand$",
              },
            }
          },
          "global/filters/additional": {
            holisticName: {
              responseKey: "holisticFilter",
              params: {
                brand_id: "$labellingBrand$", // argu mentName : componentValue
                pageName: 'campaign_labelling',
                adin_id: "$campaign$"
              },
            },
          }
        },
      },
      dailyCostReports: {
        components: {
          // brand Selection
          dailyCostBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["dailyCostBrand", ["activeCampaigns", ["campaigns", ["date", ["applybtn"]]]]]],
        visualHierarchy: [["dailyCostBrand", "campaigns", "activeCampaigns"], ["date", "applybtn"]],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            dailyCostBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "dailyReport"
              },
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$dailyCostBrand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
                pageName: "dailyReport"
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$dailyCostBrand$",
              },
            },
          },
        },
      },
      brandDailyReportPage: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: true, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["brand", ["activeCampaigns", ["campaigns", ["date", ["applybtn"]]]]]],
        visualHierarchy: [["brand", "campaigns", "date"], ["activeCampaigns", "applybtn"]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$"
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          },
        },
      },
      performanceReportPage: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              selectAll: false,
              highlightKey: "status" //bool
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          compDate: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: false, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          product: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Products",
              searchPlaceholder: "Search Product",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          events: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Events",
              searchPlaceholder: "Search Event",
              selectAll: false,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["brand", ["campaigns", "product", "compDate", "compareDate", "events", ["applybtn"]]]],
        visualHierarchy: [
          ["brand", "campaigns", "product"],
          ["events", "compDate", "compareDate"],
          ["applybtn"]
        ],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "false",
              },
            },
          },
          "/global/filters/date": {
            compDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          },
          "global/filters/additional": {
            events: {
              responseKey: "eventNames",
              params: {
                pageName: "conversion-overview",
                sourceType: "app",
                brand_id: "$brand$", // argumentName : componentValue
              },
            },
            product: {
              responseKey: "productFilter",
              params: {
                pageName: "custom",
              },
            },
          },
        },
      },
      adjustReport: {
        components: {
          adjustBrand: { // component name
            type: "selectList", // component type
            properties: { // component properties
              "placeholder": "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [
                
              ], // select if no value selected
              deleteEntry: [
                { title: "All Brands", value: "B000001" },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            }
          },
          campaign: { // component name
            type: "selectList", // component type
            properties: {
              "placeholder": "Select a Campaign",
            },// component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [
               
              ],
              deleteEntry: [
                {
                  title: "All Campaigns",
                  value: undefined,
                  startDate: formatDateTime(new Date('2023-01-01')),
                  endDate: formatDateTime(new Date()),
                }
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            }
          },
          events: { // component name
            type: "selectCheckList", // component type
            properties: { // component properties
              "placeholder": "Select Events",
              "searchPlaceholder": "Search Event",
              "selectAll": false
            },
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            }
          },
          channels: {
            type: "selectCheckList",
            properties: {
              placeholder: "Select Channels",
              searchPlaceholder: "Search Channels",
              "selectAll": false
            },
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            }

          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              "placeholder": "Active Campaigns",
              lgSize: 2
            },
            rules: {
              autoload: false,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            
            }
          },
          applybtn: { // component name 
            type: "submit", // component type
            properties: { // component properties
              "variant": "primary",
              "class": "btn-link",
              "text": "Apply",
              resetActive: true,
              lgSize: 2
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            }
          },
        },
        hierarchy: [["adjustBrand", ["activeCampaigns", ["campaign", ["channels", "events", ["applybtn"]]]]]],
        // Active Campaigns button is hidden
        visualHierarchy: [["adjustBrand", "campaign"], ["events", "channels", "applybtn"]],
        apiRules: {
          "global/filters/additional": {
            "adjustBrand": {
              responseKey: "brandFilter",
              params: {
                pageName: "adjust",
              }
            },
            "campaign": {
              responseKey: "campaignFilter",
              params: {
                pageName: "adjust",
                brand_id: "$adjustBrand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$"
              }
            },
            "events": {
              responseKey: "eventsFilter",
              params: {
                pageName: "adjust",
                adin_id : "$campaign$",
                brand_id: "$adjustBrand$", // argumentName : componentValue
              }
            },
            "channels": {
              responseKey: "channelFilter",
              params: {
                pageName: "adjust",
                brand_id: "$adjustBrand$"
              }
            }
          }
        }
      },
      operationalPage: {
        components: {
          operationalBrand: {
            type: "selectList",
            properties: {
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, 
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true,
              isNecessary: true,
            }
          },
          year: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true, 
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
          month: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true, 
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
          applybtn: { // component name 
            type: "submit", // component type
            properties: { // component properties
              "variant": "primary",
              "class": "btn-link",
              "text": "Apply",
              resetActive: true,
              lgSize: 2
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            }
          },
        },
        hierarchy: [["operationalBrand", ["year", ["month", ["applybtn"]]]]],
        visualHierarchy: [["operationalBrand", "year", "month", "applybtn"]],
        apiRules: {
          // "/global/filters": {
          //   brand: {
          //     responseKey: "brandFilter",
          //     params: {},
          //   },
          // },
          "global/filters/additional": {
            operationalBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "operational",
              },
            },
            year: {
              responseKey: "yearFilter", 
              params: {
                pageName: "operational",
                brand_id: "$operationalBrand$", // argumentName : componentValue
              },
            },
            month: {
              responseKey: "monthFilter", 
              params: {
                pageName: "operational",
                brand_id: "$operationalBrand$", // argumentName : componentValue
                year: "$year$"
              },
            },
          },
        }
      },
      notificationsPage: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{ title: "All Brands", value: "B000001" }], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              "selectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          // source Selection
          source: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Sources",
              searchPlaceholder: "Search Sources",
              "selectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          // notification type Selection
          notificationType: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Notification Types",
              searchPlaceholder: "Search Notification Types",
              "selectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          // priority Selection
          priority: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Priorities",
              searchPlaceholder: "Search Priorities",
              "selectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          // date Selection
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },

          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["brand", ["campaigns", "source", "priority", "notificationType", "date", ["applybtn"]]]],
        visualHierarchy: [["brand", "campaigns", "source"], ["priority", "notificationType", "date", "applybtn"]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
          "/notifications/filter": {
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
              },
            },
            source: {
              responseKey: "source",
              params: {
                action: "source",
                adin_id: "$campaigns$", // argumentName : componentValue
              },
            },
            priority: {
              responseKey: "priority",
              params: {
                action: "priority",
                adin_id: "$campaigns$", // argumentName : componentValue
                source: "$source$"
              },
            },
            notificationType: {
              responseKey: "notificationType",
              params: {
                action: "notificationType",
                adin_id: "$campaigns$", // argumentName : componentValue
                source: "$source$",
                priority: "$priority$"
              },
            },
            date: {
              responseKey: "date",
              params: {
                action: "date",
              },
            }
          },
        },
      },
      paparaPerfReport: {
        components: {
          // event Selection
          product: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Product",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          event: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Event",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              "selectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: true, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },

        },
        hierarchy: ["product", "campaigns", ["event", "date", ["applybtn"]]],
        visualHierarchy: [
          ["product", "campaigns"],
          ["event", "date", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            product: {
              responseKey: "productFilter",
              params: {
                pageName: "performance_report",
              },
            },
            event: {
              responseKey: "eventsFilter",
              params: {
                pageName: "performance_report",
              },
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                pageName: "performance_report",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "B000002",
              },
            },
          },


        },
      },
      paparaPerfReportTwo: {
        components: {
          // event Selection
          products: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              placeholder: "Select a Product",
              "selectAll": false
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          events: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              placeholder: "Select a Event",
              "selectAll": false
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              "selectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: true, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },


        },
        hierarchy: ["products", "campaigns", ["events", "date", ["applybtn"]]],
        visualHierarchy: [
          ["products", "campaigns"],
          ["events", "date", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            products: {
              responseKey: "productFilter",
              params: {
                pageName: "performance_report",
              },
            },
            events: {
              responseKey: "eventsFilter",
              params: {
                pageName: "performance_report",
              },
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                pageName: "performance_report",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "B000002",
              },
            },
          },


        },
      },
      lorealReportPage: {
        components: {
          brandLoreal: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          holistic: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Holistic",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["brandLoreal", ["holistic", ["applybtn"]]]],
        visualHierarchy: [["brandLoreal", "holistic", "applybtn"]],
        apiRules: {
          "global/filters/additional": {
            brandLoreal: {
              responseKey: "brandFilter",
              params: {
                pageName: "aiBudgetOptimizer",
              },
            },
            holistic: {
              responseKey: "planFilter",
              params: {
                pageName: "aiBudgetOptimizer",
                brand_id: "$brandLoreal$", // argumentName : componentValue
              },
            },
          },
        }
      },
      creativeVideo: {
        components: {
          creativeVideoBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Brand",
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          platform: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Platform",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          videoCampaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{
                title: "All Campaigns",
                value: null,
                startDate: formatDateTime(new Date("2023-01-01")),
                endDate: formatDateTime(new Date()),
              },],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["creativeVideoBrand", ["videoCampaign",["platform"]]]],
        visualHierarchy: [
          ["creativeVideoBrand", "videoCampaign","platform"]
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            creativeVideoBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "creative",
              },
            },
            videoCampaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$creativeVideoBrand$", // argumentName : componentValue
                pageName: "creative",
              },
            },
            platform: {
              responseKey: "platformFilter",
              params: {
                pageName: "creative",
                brand_id: "$creativeVideoBrand$",
                adin_id: "$videoCampaign$"
              },
            },

          },


        },
      },
      paparaCreativeReport: {
        components: {
          paparaCreativeBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Brand",
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          platform: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Platform",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{
                title: "All Platforms",
                value: null,
              },],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [{
                title: "All Campaigns",
                value: null,
                startDate: formatDateTime(new Date("2023-01-01")),
                endDate: formatDateTime(new Date()),
              },],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
        },
        hierarchy: [["paparaCreativeBrand", ["platform",["campaign"]]]],
        visualHierarchy: [
          ["paparaCreativeBrand", "platform","campaign"]
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            paparaCreativeBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "creativeReportPage",
              },
            },
            platform: {
              responseKey: "platformFilter",
              params: {
                pageName: "creativeReportPage",
                brand_id: "$paparaCreativeBrand$",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$paparaCreativeBrand$", // argumentName : componentValue
                pageName: "creativeReportPage",
                platform: "$platform$"
              },
            },

          },


        },
      },
      awarenessReport: {
        components: {
          awarenessBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
              selectAll: true,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          plan: {
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Plan",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              "selectAll": true,
              "sendNoneForSelectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
        },
        hierarchy: [["awarenessBrand",["plan",["campaign",["date"]]]]],
        visualHierarchy: ["awarenessBrand","plan","campaign","date"],
        apiRules: {
          "/global/filters/additional": {
            awarenessBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "awarenessReport",
              },
            },
            plan: {
              responseKey: "planFilter",
              params: {
                pageName: "awarenessReport",
                brand_id: "$awarenessBrand$",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "awarenessReport",
                brand_id: "$awarenessBrand$",
                brief_id: "$plan$"
              },
            },
            date: {
              responseKey: "campaignDateInfo",
              params: {
                pageName: "awarenessReport",
                brand_id: "$awarenessBrand$",
                brief_id: "$plan$",
              },
            },
          },

          // "/global/filters/date": {
            
          // },
        }
      },
      seoMonitor: {
        components: {
          seoMonitorBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
              selectAll: true,
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              "selectAll": true,
              "sendNoneForSelectAll": false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          year: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["seoMonitorBrand",["campaigns",["year",["applybtn"]]]]],
        visualHierarchy: ["seoMonitorBrand","campaigns","year","applybtn"],
        apiRules: {
          "global/filters/additional": {
            seoMonitorBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "seoMonitorPage",
              },
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                pageName: "seoMonitorPage",
                brand_id: "$seoMonitorBrand$"
              },
            },
            year: {
              responseKey: "dateFilter",
              params: {
                pageName: "seoMonitorPage",
                brand_id: "$seoMonitorBrand$",
                adin_id: "$campaigns$"

              },
            },
          },
        }
      },

      paparaPerformanceOverview: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        hierarchy: [["brand", ["date",["applybtn"]]]],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          },
        },
      },
      kpiTargetPage: {
        components: {
          brand: {
            type: "selectList",
            properties: {
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true,
              isNecessary: true,
            }
          },
          year: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
          month: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
        },
        hierarchy: [["brand", ["year", ["month"]]]],
        visualHierarchy: [["brand", "year", "month"]],
        apiRules: {
          // "/global/filters": {
          //   brand: {
          //     responseKey: "brandFilter",
          //     params: {},
          //   },
          // },
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
          },
          "global/filters/additional": {
            year: {
              responseKey: "year",
              params: {
                pageName: "kpiTarget",
              },
            },
            month: {
              responseKey: "month",
              params: {
                pageName: "kpiTarget",
              },
            },

          },
        }
      },
      monthlyAuditPage: {
        components: {
          monthlyAuditBrand: {
            type: "selectList",
            properties: {
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true,
              isNecessary: true,
            }
          },
          year: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
          month: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
        },
        hierarchy: [["monthlyAuditBrand", ["year", ["month"]]]],
        visualHierarchy: [["monthlyAuditBrand", "year", "month"]],
        apiRules: {
          "global/filters/additional": {
            monthlyAuditBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "auditOperational",
              },
            },
            year: {
              responseKey: "yearFilter",
              params: {
                pageName: "auditOperational",
                brand_id: "$monthlyAuditBrand$",
              },
            },
            month: {
              responseKey: "monthFilter",
              params: {
                pageName: "auditOperational",
                brand_id: "$monthlyAuditBrand$",
                year: "$year$"
              },
            },
          },
        }
      },
      monthlyAuditTechnicalPage: {
        components: {
          brandTechnical: {
            type: "selectList",
            properties: {
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true,
              isNecessary: true,
            }
          },
          yearTechnical: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
          monthTechnical: {
            type: "selectList",
            properties: {
              placeholder: null,
            },
            rules: {
              autoload: true,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true,
              isNecessary: true,
            }
          },
        },
        hierarchy: [["brandTechnical", ["yearTechnical", ["monthTechnical"]]]],
        visualHierarchy: [["brandTechnical", "yearTechnical", "monthTechnical"]],
        apiRules: {
          "global/filters/additional": {
            brandTechnical: {
              responseKey: "brandFilter",
              params: {
                pageName: "auditTechnical",
              },
            },
            yearTechnical: {
              responseKey: "yearFilter",
              params: {
                pageName: "auditTechnical",
                brand_id: "$brandTechnical$",
              },
            },
            monthTechnical: {
              responseKey: "monthFilter",
              params: {
                pageName: "auditTechnical",
                brand_id: "$brandTechnical$",
                year: "$yearTechnical$"
              },
            },
          },
        }
      },

      ldbReport: {
        components: {
          // brand Selection
          ldbBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              highlightKey: "status", //bool
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
              lgSize: 2,
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [
          [
            "ldbBrand",
            [
              "activeCampaigns",
              ["campaigns", "date", ["applybtn"]],
            ],
          ],
        ],
        visualHierarchy: [
          ["ldbBrand", "campaigns", "activeCampaigns"],
          ["date", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            ldbBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "ldbReport"
              },
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_ids: "$ldbBrand$",
                active_campaigns: "$activeCampaigns$",
                pageName: "ldbReport"
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_ids: "$ldbBrand$",
              },
            },
          },
        },
      },
      collaborativePage: {
        components: {
          // brand Selection
          brand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          campaigns: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Campaigns",
              searchPlaceholder: "Search Campaign",
              selectAll: false,
              highlightKey: "status" //bool
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          compDate: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",

            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["brand",["activeCampaigns", ["campaigns", "compDate", "compareDate", ["applybtn"]]]]],
        visualHierarchy: [
          ["brand", "campaigns", "activeCampaigns"],
          ["compDate", "compareDate","applybtn"]
        ],
        apiRules: {
          // api conf. for components
          "/global/filters": {
            brand: {
              responseKey: "brandFilter",
              params: {},
            },
            campaigns: {
              responseKey: "campaignFilter",
              params: {
                brand_id: "$brand$", // argumentName : componentValue
                active_campaigns: "$activeCampaigns$",
              },
            },
          },
          "/global/filters/date": {
            compDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$brand$",
              },
            },
          }
        },
      },
      parametricOptimizationPage: {
        components: {
          // brand Selection
          parametricBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              dataType: "brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
              
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          
        },
        hierarchy: [["parametricBrand", ["campaign"]]],
        visualHierarchy: ["parametricBrand", "campaign"],
        apiRules: {
          // api conf. for components
          "global/filters/additional": {
            parametricBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "parametricopt",
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "parametricopt",
                brand_id: "$parametricBrand$", // argumentName : componentValue
              },
            },
           
          },
        },
      },
      creativePage: {
        components: {
          // brand Selection
          creativeBrand: {
            // component name
            type: "selectList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [], // select if no value selected
              deleteEntry: [{ title: "All Brands", value: "B000001" }],
              selectFirst: true, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          // campaign Selection
          campaign: {
            // component name
            type: "selectList", // component type
            properties: {
              placeholder: "Select a Campaign",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [
                  {
                title: "All Campaigns",
                value: null,
                startDate: formatDateTime(new Date("2023-01-01")),
                endDate: formatDateTime(new Date()),
              },
              ],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          activeCampaigns: {
            type: "checkBox",
            properties: {
              placeholder: "Active Campaigns",
            },
            rules: {
              autoload: true,
              defaultEntry: { value: true },
              deleteEntry: [],
              selectFirst: true,
              isNecessary: false,
            },
          },
        },
        hierarchy: [["creativeBrand", ["activeCampaigns", ["campaign"]]]],
        visualHierarchy: ["creativeBrand", "campaign", "activeCampaigns"],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            creativeBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "creativePage"
              },
            },
            campaign: {
              responseKey: "campaignFilter",
              params: {
                pageName: "creativePage",
                brand_id: "$creativeBrand$",
                active_campaigns: "$activeCampaigns$",
              },
            },
          },
        },
      },
      cpasOverview: {
        components: {
          // brand Selection
          cpasBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              searchPlaceholder: "Search Brand",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasObjective: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Objective",
              searchPlaceholder: "Search Objective",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["cpasBrand",["cpasObjective", ["date", "compareDate", ["applybtn"]]]]],
        visualHierarchy: [
          ["cpasBrand", "cpasObjective", "date", "compareDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            cpasBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "cpas"
              },
            },
            cpasObjective: {
              responseKey: "objectiveFilter",
              params: {
                brand_id: "$cpasBrand$",
                pageName: "cpas"
              },
            }, 
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasBrand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasBrand$",
              },
            },
          },
        },
      },
      cpasRetailer: {
        components: {
          // brand Selection
          cpasRetailerBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Brand",
              searchPlaceholder: "Search Brand",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasRetailerPlatform: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Platform",
              searchPlaceholder: "Search Platform",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasRetailerRetailer: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Retailer",
              searchPlaceholder: "Search Retailer",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["cpasRetailerBrand",["cpasRetailerPlatform", "cpasRetailerRetailer","date", "compareDate", ["applybtn"]]]],
        visualHierarchy: [
          ["cpasRetailerBrand", "cpasRetailerPlatform", "cpasRetailerRetailer", "date", "compareDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            cpasRetailerBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "cpas_retail"
              },
            },
            cpasRetailerPlatform: {
              responseKey: "platformFilter",
              params: {
                brand_id: "$cpasRetailerBrand$",
                pageName: "cpas_retail",
              },
            },
            cpasRetailerRetailer: {
              responseKey: "retailerFilter",
              params: {
                brand_id: "$cpasRetailerBrand$",
                pageName: "cpas_retail",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasRetailerBrand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasRetailerBrand$",
              },
            },
          },
        },
      },
      cpasMeta: {
        components: {
          // brand Selection
          cpasMetaBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Brands",
              searchPlaceholder: "Search Brand",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasMetaRetailer: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Retailers",
              searchPlaceholder: "Search Retailer",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasMetaObjective: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Objectives",
              searchPlaceholder: "Search Objective",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["cpasMetaBrand", ["cpasMetaRetailer", "cpasMetaObjective", "date", "compareDate", ["applybtn"]]]],
        visualHierarchy: [
          ["cpasMetaBrand","cpasMetaRetailer", "cpasMetaObjective", "date", "compareDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            cpasMetaBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "cpas_meta"
              },
            },
            cpasMetaRetailer: {
              responseKey: "retailerFilter",
              params: {
                // brand_id: "B000034,B000040,B000037,B000038,B000029,B000039,B000036,B000002,B000035",
                brand_id: "$cpasMetaBrand$",
                pageName: "cpas_meta",
              },
            },
            cpasMetaObjective: {
              responseKey: "objectiveTypesFilter",
              params: {
                // brand_id: "B000034,B000040,B000037,B000038,B000029,B000039,B000036,B000002,B000035",
                brand_id: "$cpasMetaBrand$",
                pageName: "cpas_meta",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                // brand_id: "B000034,B000040,B000037,B000038,B000029,B000039,B000036,B000002,B000035",
                brand_id: "$cpasMetaBrand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasMetaBrand$",
              },
            },
          },
        },
      },
      cpasBrandDetail: {
        components: {
          // brand Selection
          cpasBrandDetail: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Brands",
              searchPlaceholder: "Search Brand",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasBrandDetailRetailer: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Retailers",
              searchPlaceholder: "Search Retailer",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasBrandDetailPlatform: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select a Platform",
              searchPlaceholder: "Search Platform",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasBrandDetailObjective: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Objectives",
              searchPlaceholder: "Search Objective",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["cpasBrandDetail", ["cpasBrandDetailRetailer", "cpasBrandDetailPlatform", "cpasBrandDetailObjective", "date", "compareDate", ["applybtn"]]]],
        visualHierarchy: [
          ["cpasBrandDetail","cpasBrandDetailRetailer", "cpasBrandDetailPlatform", "cpasBrandDetailObjective", "date", "compareDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            cpasBrandDetail: {
              responseKey: "brandFilter",
              params: {
                pageName: "cpas_brand_detail"
              },
            },
            cpasBrandDetailRetailer: {
              responseKey: "retailerFilter",
              params: {
                brand_id: "$cpasBrandDetail$",
                pageName: "cpas_brand_detail",
              },
            },
            cpasBrandDetailPlatform: {
              responseKey: "platformFilter",
              params: {
                brand_id: "$cpasBrandDetail$",
                pageName: "cpas_brand_detail",
              },
            },
            cpasBrandDetailObjective: {
              responseKey: "objectiveFilter",
              params: {
                brand_id: "$cpasBrandDetail$",
                pageName: "cpas_brand_detail",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasBrandDetail$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasBrandDetail$",
              },
            },
          },
        },
      },
      cpasGoogle: {
        components: {
          // brand Selection
          cpasGoogleBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Brands",
              searchPlaceholder: "Search Brand",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasGoogleRetailer: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Retailers",
              searchPlaceholder: "Search Retailer",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasGoogleObjective: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Objectives",
              searchPlaceholder: "Search Objective",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["cpasGoogleBrand", ["cpasGoogleRetailer", "cpasGoogleObjective", "date", "compareDate", ["applybtn"]]]],
        visualHierarchy: [
          ["cpasGoogleBrand","cpasGoogleRetailer", "cpasGoogleObjective", "date", "compareDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            cpasGoogleBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "cpas_google"
              },
            },
            cpasGoogleRetailer: {
              responseKey: "retailerFilter",
              params: {
                brand_id: "$cpasGoogleBrand$",
                pageName: "cpas_google",
              },
            },
            cpasGoogleObjective: {
              responseKey: "objectiveTypesFilter",
              params: {
                brand_id: "$cpasGoogleBrand$",
                pageName: "cpas_google",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasGoogleBrand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasGoogleBrand$",
              },
            },
          },
        },
      },
      cpasDataTypes: {
        components: {
          // brand Selection
          cpasDataTypesBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Brands",
              searchPlaceholder: "Search Brand",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasDataTypesDataType: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Data Types",
              searchPlaceholder: "Search Data Type",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasDataTypesPlatform: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Platform",
              searchPlaceholder: "Search Platform",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          cpasDataTypesObjective: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Select Objectives",
              searchPlaceholder: "Search Objective",
              selectAll: false,
              isSelectAllShowing: true, // is select all option showing
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false, // select first value if no value selected
              isNecessary: true, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Current Date:"
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compareDate: {  
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
              title: "Compare Date:",
              
            }, // component properties
            rules: {
              autoload: false, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["cpasDataTypesBrand", ["cpasDataTypesDataType","cpasDataTypesPlatform", "cpasDataTypesObjective", "date", "compareDate", ["applybtn"]]]],
        visualHierarchy: [
          ["cpasDataTypesBrand","cpasDataTypesDataType", "cpasDataTypesPlatform", "cpasDataTypesObjective", "date", "compareDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            cpasDataTypesBrand: {
              responseKey: "brandFilter",
              params: {
                pageName: "cpas_data_type"
              },
            },
            cpasDataTypesDataType: {
              responseKey: "dataTypeFilter",
              params: {
                brand_id: "$cpasDataTypesBrand$",
                pageName: "cpas_data_type",
              },
            },
            cpasDataTypesPlatform: {
              responseKey: "platformFilter",
              params: {
                brand_id: "$cpasDataTypesBrand$",
                pageName: "cpas_data_type",
              },
            },
            cpasDataTypesObjective: {
              responseKey: "objectiveFilter",
              params: {
                brand_id: "$cpasDataTypesBrand$",
                pageName: "cpas_data_type",
              },
            },
          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasDataTypesBrand$",
              },
            },
            compareDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$cpasDataTypesBrand$",
              },
            },
          },
        },
      },
      cpasInvestmentRevenue: {
        components: {
          // brand Selection
          investmentBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Investment Brands",
              searchPlaceholder: "Search Investment Brand",
              highlightKey: "status", //bool
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          revenueBrand: {
            // component name
            type: "selectCheckList", // component type
            properties: {
              // component properties
              placeholder: "Revenue Brands",
              searchPlaceholder: "Search Revenue Brand",
              highlightKey: "status", //bool
              selectAll: false
            },
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: true, // select first value if no value selected
              isNecessary: false, // is it mandoatory
            },
          },
          date: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          compDate: {
            // component name
            type: "selectDate", // component type
            properties: {
              placeholder: null,
              dateMaxRangePlaceholder: "All Time",
            }, // component properties
            rules: {
              autoload: true, // autoload data when page loaded (save selected value)
              defaultEntry: false,
              deleteEntry: [], // not defined for datepicker
              selectFirst: true, // not defined for datepicker
              isNecessary: false, // is it mandoatory
            },
          },
          applybtn: {
            // component name
            type: "submit", // component type
            properties: {
              // component properties
              variant: "primary",
              class: "btn-link",
              text: "Apply",
              resetActive: true,
              lgSize: 2,
            },
            rules: {
              autoload: false,
              defaultEntry: [],
              deleteEntry: [],
              selectFirst: false,
              isNecessary: true,
            },
          },
        },
        canBeSaved: true,
        hierarchy: [["investmentBrand", ["date", "compDate"]], "revenueBrand", ["applybtn"]],
        visualHierarchy: [
          ["investmentBrand", "revenueBrand", "date", "compDate", "applybtn"],
        ],
        apiRules: {
          // api conf. for components
          "/global/filters/additional": {
            investmentBrand: {
              responseKey: "investmentBrand",
              params: {
                pageName: "cpasInvestmentRevenue"
              },
            },
            revenueBrand: {
              responseKey: "revenueBrand",
              params: {
                pageName: "cpasInvestmentRevenue"
              },
            },

          },
          "/global/filters/date": {
            date: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$investmentBrand$",
                pageName: "cpasInvestmentRevenue"
              },
            },
            compDate: {
              responseKey: "campaignDateInfo",
              params: {
                brand_id: "$investmentBrand$",
                pageName: "cpasInvestmentRevenue"
              },
            },
          },
        },
      },
    },
    componentType: {
      select: "selectList",
      date: "selectDate",
      check: "checkBox",
      checkList: "selectCheckList",
    },
    filterData: {},
    previousFilterData: {},
    apiData: {
      apiRules: {},
      apiNameMap: {},
    },
    hierarchy: {},
  },
  getters: {
    getFilterConfig: (state) => (configName) => {
      return state.configs[configName];
    },
    getAPIRules: (state) => (componentName) => {
      return state.apiData.apiRules[componentName];
    },
    // getFilterData: (state) => {
    //   return state.filterData;
    // },
    // getPreviousFilterData: (state) => {
    //   return state.previousFilterData;
    // },
    getApiData: (state) => {
      return state.apiData;
    },
    getHierarchy: (state) => {
      return state.hierarchy;
    },
    getLoadingStatus: (state) => (componentName) => {
      return state.filterData[componentName]?.loading ?? false;
    },
  },
  mutations: {
    // appendNewDataToList(state, payload) {
    //   state.filterData[payload.name].data.push(payload.newData);
    // },
    // updateSelectedValue(state, payload) {
    //   state.filterData[payload.name].selected = payload.selected;
    // },
    // setFilterData(state, payload) {
    //   state.filterData = payload;
    // },
    // setPreviousFilterData(state, payload) {
    //   state.previousFilterData = payload;
    // },
    // updateComponentFilterData(state, payload) {
    //   state.filterData[payload.name] = payload;
    // },
    setApiData(state, payload) {
      state.apiData = payload;
    },
    setHierarchy(state, payload) {
      state.hierarchy = payload;
    },
    changeLoadingStatus(state, payload) {
      const isComponentExist = state.filterData[payload.componentName]
      if (isComponentExist) {
        state.filterData[payload.componentName]["loading"] = payload.loading;
      } else {
        state.filterData[payload.componentName] = {
          loading: payload.loading
        }
      }
    },
    setFilterDbLoading(state, isLoading) {
      state.isFilterDbLoading = isLoading;
    },
    setFilterDbError(state, error) {
      state.filterDbError = error;
    },
  },
  actions: {
    // Action to load data
    async loadFiltersFromDB({ commit }) {
      commit('setFilterDbLoading', true); 
      commit('setFilterDbError', null);   
      try {
        const current = await getDbFilterData(CURRENT_FILTER_KEY);
        const previous = await getDbFilterData(PREVIOUS_FILTER_KEY);
        return { current, previous };
      } catch (error) {
        commit('setFilterDbError', 'Failed loading filters');
        console.error("Action Error: loadFiltersFromDB", error);
        return { current: null, previous: null };
      } finally {
        commit('setFilterDbLoading', false);
      }
    },

    // Action to save current data
    async saveCurrentFilterDataAction({ commit }, newFilterData) {
      commit('setFilterDbLoading', true);
      commit('setFilterDbError', null);
      try {
        await saveDbFilterData(CURRENT_FILTER_KEY, newFilterData);
      } catch (error) {
        commit('setFilterDbError', 'Failed saving current filter');
        console.error("Action Error: saveCurrentFilterDataAction", error);
        throw error;
      } finally {
        commit('setFilterDbLoading', false);
      }
    },

     // Action to append data (replaces appendNewDataToList mutation)
  async appendComponentDataAction({ commit, dispatch }, payload) {
    commit('setFilterDbLoading', true); 
    commit('setFilterDbError', null);   
    try {
      const currentFilterData = await getDbFilterData(CURRENT_FILTER_KEY) || {};

      const componentData = currentFilterData[payload.name] || {};
      if (!Array.isArray(componentData.data)) {
        componentData.data = []; // Ensure 'data' property is an array
      }
      componentData.data.push(payload.newData); // Append the new item
      currentFilterData[payload.name] = componentData; // Update the main object

      await dispatch('saveCurrentFilterDataAction', currentFilterData);

    } catch (error) {
      const errorMsg = `Failed appending data for ${payload.name}`;
      commit('setFilterDbError', errorMsg); // Use your preferred mutation case
      console.error("Action Error: appendComponentDataAction", error);
      throw new Error(errorMsg); // Re-throw or handle as needed
    } finally {
      // Loading state might already be set to false by the dispatched save action,
      // but setting it here ensures it happens even if an error occurs before dispatching.
      commit('setFilterDbLoading', false); // Use your preferred mutation case
    }
  },

  // Action to update selection (replaces updateSelectedValue mutation)
  async updateComponentSelectionAction({ commit, dispatch }, payload /* { name: string, selected: any } */) {
    commit('setFilterDbLoading', true);
    commit('setFilterDbError', null);
    try {
      // 1. Read current data from DB
      const currentFilterData = await getDbFilterData(CURRENT_FILTER_KEY) || {};

      // 2. Modify data in memory
      const componentData = currentFilterData[payload.name] || {};
      componentData.selected = payload.selected; // Update the 'selected' property
      currentFilterData[payload.name] = componentData;

      // 3. Dispatch action to save modified current data
      await dispatch('saveCurrentFilterDataAction', currentFilterData);

    } catch (error) {
      const errorMsg = `Failed updating selection for ${payload.name}`;
      commit('setFilterDbError', errorMsg);
      console.error("Action Error: updateComponentSelectionAction", error);
      throw new Error(errorMsg);
    } finally {
      commit('setFilterDbLoading', false);
    }
  },

  // Action to update/replace a whole component's filter data (replaces updateComponentFilterData mutation)
  async updateComponentObjectAction({ commit, dispatch }, payload /* { name: string, ...componentData } */) {
    commit('setFilterDbLoading', true);
    commit('setFilterDbError', null);
    try {
      // 1. Read current data from DB
      const currentFilterData = await getDbFilterData(CURRENT_FILTER_KEY) || {};

      // 2. Modify data in memory
      const componentDataToStore = { ...payload };
      currentFilterData[payload.name] = componentDataToStore; // Replace/add component data

      // 3. Dispatch action to save modified current data
      await dispatch('saveCurrentFilterDataAction', currentFilterData);

    } catch (error) {
      const errorMsg = `Failed updating component object for ${payload.name}`;
      commit('setFilterDbError', errorMsg);
      console.error("Action Error: updateComponentObjectAction", error);
      throw new Error(errorMsg);
    } finally {
      commit('setFilterDbLoading', false);
    }
  },

  // Action to save previous data directly (replaces setPreviousFilterData mutation)
  async savePreviousFilterDataAction({ commit }, previousFilterData) {
    commit('setFilterDbLoading', true);
    commit('setFilterDbError', null);
    try {
      // Directly save the provided data to the 'previous' key in IndexedDB
      await saveDbFilterData(PREVIOUS_FILTER_KEY, previousFilterData);

    } catch (error) {
      const errorMsg = 'Failed saving previous filter data directly';
      commit('setFilterDbError', errorMsg);
      console.error("Action Error: savePreviousFilterDataAction", error);
      throw new Error(errorMsg);
    } finally {
      commit('setFilterDbLoading', false);
    }
  },
  }
};